// extracted by css-extract-rspack-plugin
export default {"placeholder":"_65b61fbd","additionalBlur":"_29eeb4ee"};